export const DRUPAL_MENU_TYPES = {
  HEADER: "main",
  FOOTER: "footer",
  TOP_HEADER: "top-header-menu",
  POSTLOGIN_HEADER: "user-dashboard-menu",
};

export const DRUPAL_FORM_TYPES = {
  FORM_FIELD_COMPONENT: "form_field_component",
  FORM_CTA_COMPONENT: "form_cta_component",
  SEPARATOR_COMPONENT: "separator_component",
  SPACER_COMPONENT: "row",
};

export const NAVIGATION_TYPES = {
  HEADER_FOOTER: "header",
};

export const SLUG_TYPES = {
  LOGIN: "login",
  FORGOTPASSWORD: "donor-forgot-password",
  RESETPASSWORD: "reset-password",
  LOCATIONS: "locations",
  NOCENTERFOUND: "no-center-zone",
  REGISTRATION: "registration",
  CREATEACCOUNT: "create-account",
  FORGOTPASSWORDCONFIRMATION: "check-email",
  ACCOUNTUPDATECONFIRMATION: "social-login-success",
  CONTACT_US: "contact-us",
  SIGNUPFINALSTEP: "email-confirmation",
  SIGNUPEMAILCONFIRM: "verify-email",
  SOCIALLOGIN: "social-login",
  LOCATION_NOT_FOUND: "locations/location-not-found",
  LOCATIONS_STATE: "locations/state",
  LOCATIONS: "locations",
  SHAREWITHUS: "share-with-us",
  MESSAGES: "messages",
  CHOOSEDONATIONCENETR: "choose-donation-center",
  SETTINGS: "settings",
  PROMOTIONALBANNER: "promotional-banner",
};

export const SLUG_TYPES_MOBILE = {
  WELCOME: "welcome-app",
  LOGIN: "login-app",
  DASHBOARD: "dashboard-app",
  ONBOARDING_EXPERIENCE: "onboarding-experience",
  REGISTRATION: "registration-app",
  CREATE_PROFILE: "create-account-app",
  SIGNUP_FINAL_STEP: "email-confirmation-app",
  NO_CENTER_ZONE: "no-center-zone-app",
  MY_APPOINTMENTS: "my-appointments-app",
  APPOINTMENT_DETAILS: "appointment-detail-app",
  MY_REWARDS_APP: "my-rewards-app",
  MY_DEBIT_APP: "my-debit-app",
  FORGOT_PASSWORD: "forgot-password-app",
  FORGOT_PASSWORD_CONFIRMATION: "forgot-password-success-app",
  FAQ: "faqs-app",
  DISCOVER: "discover-app",
  REFER_FRIEND_DONOR: "refer-friend-donor-app",
  REFER_FRIEND_INITIAL: "refer-friend-initial-app",
  REWARDS_HISTORY: "rewards-history-app",
  PROMOTIONS: "promotions-app",
  APPOINTMENT_HISTORY: "appointment-history-app",
  PAYMENT_HISTORY: "payment-history-app",
  DEBIT_HISTORY: "debit-history-app",
  ACCOUNT_SETTINGS: "settings-app",
  MIGRATED_USER_SUCCESS: "migrated-login-app",
};

export const ROUTE_TO_SLUG_MAP = {
  Welcome: "welcome-app",
  SignIn: "login-app",
  Dashboard: "dashboard-app",
  SignUp: "registration-app",
  CreateProfile: "create-account-app",
  EmailConfirmation: "email-confirmation-app",
  NoCenters: "no-center-zone-app",
  MyAppointments: "my-appointments-app",
  AppointmentDetails: "appointment-detail-app",
  // Rewards: 'my-rewards-app',   This is commented out because of tab drupal logic and handled within route container
  // Rewards: 'my-debit-app',     This is commented out because of tab drupal logic and handled within route container
  AuthForgotPassword: "forgot-password-app",
  AuthForgotPasswordSuccess: "forgot-password-success-app",
  FAQ: "faqs-app",
  Discover: "discover-app",
  // REFER_FRIEND_DONOR: 'refer-friend-donor-app',      This is commented out because of tab drupal logic and handled within route container
  // REFER_FRIEND_INITIAL: 'refer-friend-initial-app',  This is commented out because of tab drupal logic and handled within route container
  RewardsHistory: "rewards-history-app",
  Promotions: "promotions-app",
  AppointmentHistory: "appointment-history-app",
  PaymentHistory: "payment-history-app",
  DebitHistory: "debit-history-app",
  Settings: "settings-app",
};

export const GROUP_FORM_SLUG = {
  REGISTRATION: "registration",
  LOGIN: "login",
  CONTACT_US: "contact-us",
  "ABOUT-BIOLIFE/CONTACT-US": "about-biolife/contact-us",
  "SHARE-WITH-US": "share-with-us",
  "SOCIAL-LOGIN": "social-login",
  "DONOR-FORGOT-PASSWORD": "donor-forgot-password",
  "RESET-PASSWORD": "reset-password",
};

export default {
  DRUPAL_MENU_TYPES,
  NAVIGATION_TYPES,
  SLUG_TYPES,
  DRUPAL_FORM_TYPES,
  SLUG_TYPES_MOBILE,
  ROUTE_TO_SLUG_MAP,
};
